import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import './Tooltip.module.scss';

const CustomTooltip = ({ children, placement, text, id, delay }) => (
  <OverlayTrigger
    delay={delay}
    placement={placement ?? 'top'}
    overlay={<Tooltip id={id ?? 'boon-tooltip'}>{text}</Tooltip>}
  >
    {children}
  </OverlayTrigger>
);

export default CustomTooltip;
